import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pghDictionary',
    standalone: true
})
export class DictionaryPipe implements PipeTransform {
  transform(value: any, args: any) {
    if (!value || value === undefined) {
      return '';
    } else if (!args) {
      return value;
    } else {
      return Object.keys(args).reduce((final, arg) =>
        final.replace(`{${arg}}`, args[arg])
        , value);
    }
  }

}
